<template>
  <div>
    <!-- Search bar -->
    <v-card-text class="pb-0 pt-3 px-4">
      <v-text-field
        v-model="searchInput"
        outlined
        dense
        hide-details
        clearable
        label="Search by stock code, product or brand"
        prepend-inner-icon="mdi-magnify"
        style="max-width: 420px"
      />
    </v-card-text>

    <v-data-table
      :headers="headers"
      :items="stockList"
      :footer-props="{ 'items-per-page-options': [10, 20, 50] }"
      :items-per-page.sync="itemsPerPage"
      :page.sync="page"
      :server-items-length="stockCount"
      :loading="stockLoading"
      loading-text="Loading stocks..."
      class="elevation-0"
      dense
    >
      <template #item.retail="{ value }">
        <span>₱ {{ formatMoney(value) }}</span>
      </template>

      <template #item.actions="{ item }">
        <v-btn
          v-if="authPermissions.has('stocks:edit')"
          icon
          small
          color="primary"
          @click="editStock(item)"
        >
          <v-icon small>
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>

      <template #no-data>
        <div class="py-6 text-center grey--text">
          <v-icon large>
            mdi-package-variant
          </v-icon>
          <div class="mt-1">
            No stocks found
          </div>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { moneyMixin } from './../../mixins/helper.mixins'
import stockRepository from '@/repositories/stock.repository'
import { apiVars } from '@/extra-functions/api-helper.extra'
import { errorHandler } from '@/extra-functions/store.extra'
import { useDebounce } from '@/lib/utils'

const searchDebounce = useDebounce(400)

export default {
  name: 'VIndexStock',

  mixins: [moneyMixin],

  data() {
    return {
      ...apiVars('stock'),
      searchInput: null,
      stockCount: 0,
      itemsPerPage: 10,
      page: 1,
      headers: [
        { text: 'Stock Code', value: 'stock_code', sortable: false },
        { text: 'Barcode', value: 'barcode', sortable: false },
        { text: 'Product Name', value: 'product_name', sortable: false },
        { text: 'Brand', value: 'brand_name', sortable: false },
        { text: 'Unit', value: 'unit', sortable: false },
        { text: 'Retail Price', value: 'retail', sortable: false, align: 'right' },
        { text: '', value: 'actions', sortable: false, align: 'center', width: 56 },
      ],
    }
  },

  computed: {
    ...mapState({
      stockUpdated: state => state.stock.channelUpdate,
      storeId: state => state.settings.storeId,
      authPermissions: state => state.auth.userPermissions,
    }),
  },

  watch: {
    searchInput() {
      this.page = 1
      searchDebounce(() => this.refreshData())
    },
    itemsPerPage() {
      this.fetchCurrentPage()
    },
    page() {
      this.fetchCurrentPage()
    },
    stockUpdated() {
      this.refreshData()
    },
  },

  created() {
    this.refreshData()
  },

  methods: {
    editStock(stockData) {
      this.$emit('editStock', stockData)
    },

    fetchCurrentPage() {
      this.stockLoading = true
      const index = (this.page - 1) * this.itemsPerPage
      stockRepository
        .storeList(this.storeId, { index, limit: this.itemsPerPage, search: this.searchInput })
        .then(({ data }) => { this.stockList = data })
        .catch(e => { this.stockErrors = errorHandler(e) })
        .finally(() => { this.stockLoading = false })
    },

    fetchDataCount() {
      stockRepository
        .storeCount(this.storeId, { search: this.searchInput })
        .then(({ data }) => { this.stockCount = data })
    },

    refreshData() {
      this.fetchDataCount()
      this.fetchCurrentPage()
    },
  },
}
</script>
